// Generates a Superhive asset-library capability URL from the pickup modal.
// The URL embeds an shl_ secret returned once by POST /account/api_tokens
// (JSON, scope_preset asset_library); it is never retrievable again.
import { requestApiToken, defaultTokenName } from "./request_token"

function generateLibraryUrl(event) {
  requestApiToken(event, {
    errorSelector: ".js-generate-library-url-error",
    scopePreset: "asset_library",
    failureMessage: "Could not create a Workstation Link.",
    tokenName: function ($modal) {
      var customName = $modal.find(".js-library-link-name").val()
      return (customName || "").trim() || defaultTokenName()
    },
    onSuccess: function ($modal, data) {
      $modal.find("#generatedLibraryUrl").text(data.library_url)
      $modal.find(".js-generate-library-url-intro").addClass("d-none")
      $modal.find(".js-generate-library-url-result").removeClass("d-none")
    },
  })
}

// Direct binding (namespaced so rebinds never stack). Content injected after
// page load (e.g. the product assets tab arriving via XHR) must call this
// again — see initializeAssetsTabHandlers.
export function bindGenerateLibraryUrl() {
  $(".js-generate-library-url")
    .off("click.generateLibraryUrl")
    .on("click.generateLibraryUrl", generateLibraryUrl)
}

$(document).on("turbolinks:load", bindGenerateLibraryUrl)
